export default __webpack_public_path__ + "static/media/close-blue.4501b5af.svg";